import type {
  PageState,
  PaginatorContext,
  PaginatorPassThroughOptions,
  PaginatorProps,
  PaginatorSlots,
} from 'primevue';
import { PassThrough } from '@primevue/core';
import { ComponentPublicInstance } from 'vue';

export type PassThroughMeridiaPaginator =
  PassThrough<PaginatorPassThroughOptions>;

export type MeridiaPaginatorProps = PaginatorProps;

export type MeridiaPaginatorEmits = {
  /**
   * Emitted when the first changes.
   * @param {number} value - New value.
   */
  'update:first'(value: number): true;
  /**
   * Emitted when the rows changes.
   * @param {number} value - New value.
   */
  'update:rows'(value: number): true;
  /**
   * Callback to invoke when page changes, the event object contains information about the new state.
   * @param {PageState} event - New page state.
   */
  page(event: PageState): true;
};

export type MeridiaPaginatorSlots = PaginatorSlots;

export type MeridiaPaginator = ComponentPublicInstance<
  MeridiaPaginatorProps,
  MeridiaPaginatorEmits,
  MeridiaPaginatorSlots
>;

export const MeridiaPaginatorPassThroughValues = {
  root: {
    class: ['bg-transparent'],
  },
  page: ({ context }: { context: PaginatorContext }) => {
    return {
      class: {
        'h-xl radius-xlarge hover:bg-neutral-surface-disabled hover:text-neutral-text-body':
          true,
        'bg-neutral-surface-disabled text-neutral-text-body text-caption-large':
          context.active,
        'text-body-large': !context.active,
      },
    };
  },
  next: {
    class: [
      'h-xl radius-xlarge hover:bg-neutral-surface-disabled hover:text-neutral-text-body',
    ],
  },
  last: {
    class: [
      'h-xl radius-xlarge hover:bg-neutral-surface-disabled hover:text-neutral-text-body',
    ],
  },
} as PassThroughMeridiaPaginator;
